import { darken } from '../../../../helpers';
var darkenValue = 10;
var alerts = {
  success: {
    color: "#3c763d",
    bg: "#dff0d8",
    border: darken("#dff0d8", darkenValue)
  },
  info: {
    color: "#31708f",
    bg: "#d9edf7",
    border: darken("#d9edf7", darkenValue)
  },
  warning: {
    color: "#8a6d3b",
    bg: "#fcf8e3",
    border: darken("#fcf8e3", darkenValue)
  },
  danger: {
    color: "#a94442",
    bg: "#f2dede",
    border: darken("#f2dede", darkenValue)
  }
};
export default alerts;